import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Relative dependencies.
import { SCWShardsAccessComponent } from './access.component';

@NgModule({
  imports: [ CommonModule ],
  exports: [ SCWShardsAccessComponent ],
  declarations: [ SCWShardsAccessComponent ],
  providers: [],
})
export class SCWShardsAccessModule {
  
}